import React from 'react';

import Dropdown from 'ub/components/dropdown/dropdown';

const DEFAULT_LINEHEIGHTS = [
  '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
  '22', '24', '26', '29', '31', '32', '34', '35', '38', '42', '43', '45',
  '58', '77', '86', '115'
];

export default class LineHeight extends React.Component {
  constructor(props) {
    super(props);

    this.changeLineHeight = this.changeLineHeight.bind(this);

    this.lineHeightOptionMap = this.getOptionsList();
  }

  componentWillUpdate() {
    this.lineHeightOptionMap = this.getOptionsList();
  }

  getOptionsList() {
    return DEFAULT_LINEHEIGHTS.map((value) => {
      return {
        value,
        label: value,
        selected: parseInt(value, 10) === parseInt(this.props.lineHeight, 10)
      };
    });
  }

  changeLineHeight(val) {
    this.props.changeHandler({
      type: 'lineHeightChange',
      value: val
    });
  }

  render() {
    return (
      <Dropdown
        className="line-height-dropdown"
        value={this.props.lineHeight.toString()}
        label={this.props.lineHeight.toString()}
        options={this.lineHeightOptionMap}
        changeHandler={this.changeLineHeight}
      />
    );
  }
}

LineHeight.propTypes = {
  lineHeight: React.PropTypes.number,
  changeHandler: React.PropTypes.func
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/style-tab-content-components/line-height.jsx